module.exports = __webpack_public_path__ + "media/1_3_2-1.3879eab5.mp3";